import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { cn } from "../../../lib/utils";

interface NumberTickerProps {
  value: number;
  direction?: "up" | "down";
  delay?: number;
  className?: string;
  decimalPlaces?: number;
  prefix?: string;
  suffix?: string;
  duration?: number;
}

export const NumberTicker: React.FC<NumberTickerProps> = ({
  value,
  direction = "up",
  delay = 0,
  className,
  decimalPlaces = 0,
  prefix = "",
  suffix = "",
  duration = 2,
}) => {
  const [hasStarted, setHasStarted] = useState(false);
  const motionValue = useMotionValue(direction === "down" ? value : 0);
  const rounded = useTransform(motionValue, (latest) => {
    return latest.toFixed(decimalPlaces);
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasStarted(true);
      const controls = animate(motionValue, value, {
        duration,
        ease: "easeOut",
      });
      return controls.stop;
    }, delay * 1000);

    return () => clearTimeout(timer);
  }, [motionValue, value, delay, duration]);

  return (
    <motion.span
      className={cn("font-mono text-lg font-bold", className)}
      initial={{ opacity: 0, y: direction === "up" ? 20 : -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
    >
      {prefix}
      <motion.span>{rounded}</motion.span>
      {suffix}
    </motion.span>
  );
};